// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CONVERT_TO_DISCUSSION_MODAL_DESCRIPTION = "V Diskusi\u00e1ch ju uvid\u00ed viac \u013eud\u00ed.";
export const CONVERT_TO_DISCUSSION_MODAL_DESCRIPTION2 = "Viac \u013eud\u00ed = viac r\u00e1d, sk\u00fasenost\u00ed a odpoved\u00ed.";
export const CONVERT_TO_DISCUSSION_MODAL_DESCRIPTION3 = "Tvoja ot\u00e1zka si zasl\u00fa\u017ei viac.";
export const CONVERT_TO_DISCUSSION_MODAL_SAVE_AS_FORUM_THREAD = "Chcem viac odpoved\u00ed - zalo\u017e\u00edm diskusiu";
export const CONVERT_TO_DISCUSSION_MODAL_SAVE_AS_PHOTOBLOG_SHORT_MESSAGE = "Vytvor\u00edm len pr\u00edspevok";
export const CONVERT_TO_DISCUSSION_MODAL_SAVE_BOTH = "Vytvor\u00edm diskusiu aj pr\u00edspevok";
export const CONVERT_TO_DISCUSSION_MODAL_TITLE = "M\u00e1\u0161 ot\u00e1zku?";
